module.exports = __webpack_public_path__ + "img/red-sports-car.0bd13786.jpg";